import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Form, Row, Col, Radio, Checkbox, Select, Input } from 'antd';
import { selectCatalogValoracionesConverter } from 'selectors/catalogos.selectors';
import * as fieldMsgs from 'constants/formFieldsMessages';

const Observaciones = ({ form }) => {
  const valoracionesUTFData = useSelector(selectCatalogValoracionesConverter());
  const { TextArea } = Input;

  const [tipoValo, setTipoValo] = useState(null);

  useEffect(() => {
    setTipoValo(form.getFieldValue('tipoValoracion'));
  }, []);

  const onTipoValoracion = (e) => {
    setTipoValo(e.target.value);
  };
  return (
    <div>
      <Form form={form} layout="vertical">
        <Row>
          <Col>
            <div>
              <div className="customdiv-item-span">
                <span>
                  <span
                    style={{
                      color: '#ff4d4f',
                      fontSize: '14px',
                      marginInlineEnd: '4px'
                    }}>
                    *
                  </span>
                  Tipo de valoración:
                </span>
                <span
                  className="instruction-span-purple"
                  style={{ marginBottom: '6px', paddingLeft: '9px' }}>
                  Selecciona el tipo de propaganda.
                </span>
              </div>
              <Form.Item
                name="tipoValoracion"
                label=""
                rules={[{ required: true, message: fieldMsgs.ERR_RADIO_FIELD_REQUIRED }]}>
                <Radio.Group className="radiog radio-style" onChange={onTipoValoracion}>
                  <Radio value={1}>Propaganda</Radio>
                  <Radio value={2}>Propaganda sujeta de valoración de la UTF</Radio>
                </Radio.Group>
              </Form.Item>
            </div>
          </Col>
        </Row>
        {tipoValo === 1 ? (
          <Row>
            <Col span={23}>
              <Form.Item
                className="input-observaciones"
                name="lema"
                label="Lema:"
                rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                <TextArea
                  showCount
                  maxLength={200}
                  allowClear
                  placeholder="Escribe..."
                  size="large"
                />
              </Form.Item>
            </Col>
          </Row>
        ) : null}
        {tipoValo === 2 ? (
          <Row>
            <Col span={24}>
              <div className="customdiv-item-span">
                <span>
                  <span
                    style={{
                      color: '#ff4d4f',
                      fontSize: '14px',
                      marginInlineEnd: '4px'
                    }}>
                    *
                  </span>
                  Lista de valoración:
                </span>
                <span
                  className="instruction-span-purple"
                  style={{ marginBottom: '6px', paddingLeft: '9px' }}>
                  Selecciona la o las opciones correspondientes.
                </span>
              </div>
              <Form.Item
                name="valoraciones"
                label=""
                rules={[{ required: true, message: fieldMsgs.ERR_CHECKBOX_FIELD_REQUIRED }]}>
                <Checkbox.Group className="col-checks" options={valoracionesUTFData} />
              </Form.Item>
            </Col>
          </Row>
        ) : null}
        <Row>
          <Col span={6}>
            <Form.Item
              name="validacionCNCS"
              label="Validación de CNCS:"
              rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
              <Select
                placeholder="Selecciona..."
                options={[
                  {
                    value: 1,
                    label: 'Validado'
                  },
                  {
                    value: 2,
                    label: 'No validado'
                  }
                ]}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={23}>
            <Form.Item
              className="input-observaciones"
              name="infAdicional"
              label="Información adicional (modo, tiempo, lugar):">
              <TextArea
                showCount
                maxLength={2000}
                allowClear
                placeholder="Escribe..."
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

Observaciones.propTypes = {
  form: PropTypes.shape({ getFieldValue: PropTypes.func.isRequired }).isRequired
};

export default Observaciones;
